var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from 'react';
import defaultState from './defaultState';
import mainContextReducer from './reducer';
import { ActionType } from './types';
export var MainContext = createContext(undefined);
var MainProvider = function (_a) {
    var children = _a.children, triggerAnalyticsEvent = _a.triggerAnalyticsEvent;
    var _b = useReducer(mainContextReducer, defaultState), state = _b[0], dispatch = _b[1];
    var value = useMemo(function () { return ({
        state: __assign(__assign({}, state), { triggerAnalyticsEvent: triggerAnalyticsEvent }),
        dispatch: dispatch
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    return _jsx(MainContext.Provider, __assign({ value: value }, { children: children }));
};
function useMainContext() {
    var context = useContext(MainContext);
    if (context === undefined) {
        throw new Error('useMainContext must be used within a MainProvider');
    }
    var state = context.state, dispatch = context.dispatch;
    var setAccountId = function (accountId) {
        dispatch({ type: ActionType.SET_ACCOUNT_ID, accountId: accountId });
    };
    var setCurrentLanguage = function (currentLanguage) {
        dispatch({
            type: ActionType.SET_CURRENT_LANGUAGE,
            currentLanguage: currentLanguage
        });
    };
    var setCurrentRoute = function (currentRoute) {
        dispatch({
            type: ActionType.SET_CURRENT_ROUTE,
            currentRoute: currentRoute
        });
    };
    var setAutopayStatus = function (autopayStatus) {
        dispatch({
            type: ActionType.SET_AUTOPAY_STATUS,
            payload: __assign(__assign({}, state), { autopayStatus: autopayStatus })
        });
    };
    return __assign(__assign({}, state), { dispatch: dispatch, setAccountId: setAccountId, setAutopayStatus: setAutopayStatus, setCurrentLanguage: setCurrentLanguage, setCurrentRoute: setCurrentRoute });
}
export { MainProvider, useMainContext };
//# sourceMappingURL=index.js.map